import { render, staticRenderFns } from "./ManageLanguagePack.vue?vue&type=template&id=5e8327dc&scoped=true&"
import script from "./ManageLanguagePack.vue?vue&type=script&lang=js&"
export * from "./ManageLanguagePack.vue?vue&type=script&lang=js&"
import style0 from "./ManageLanguagePack.vue?vue&type=style&index=0&id=5e8327dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8327dc",
  null
  
)

export default component.exports